var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_logo"},[_c('div',{staticClass:"loading-center"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"login_Tips"},[_vm._v("登录中")])])])
}]

export { render, staticRenderFns }